import Base from 'app/views/base';

export class FormField {
  constructor({
    type = 'text', label, paramKey, defaultValue = '', placeholder = '',
  }) {
    this.type = type;
    this.label = label;
    this.paramKey = paramKey;
    this.defaultValue = defaultValue;
    this.placeholder = placeholder;
  }
}

export default Base.extend({
  events: {
    'click .show-popup': 'showPopup',
    'click .close': 'hidePopup',
    keyup: 'keyup',
  },

  showPopup(e) {
    e.preventDefault();
    this.$('.card').addClass('open').focus();
  },

  hidePopup() {
    this.$('.card').removeClass('open');
  },

  keyup(e) {
    if (e.which === 27) { this.hidePopup(); }
  },

  afterRender() {
    $('body').on('click', e => {
      // The second check is because if we use subviews and rerender them, they will be detached
      // from the DOM by the time this event fires. We should probably rewrite this class to have
      // an explicit click-out area, like modals do
      if (!$(e.target).parents('.popup-card').length && $(e.target).parents('body').length) {
        this.hidePopup();
      }
    });
  },

  remove() {
    $('body').off('click');
  },

  computeSelectionViewId(idx) {
    return `selection-view-${idx}`;
  },
});



// WEBPACK FOOTER //
// ./app/components/popup_base/index.js